import resources from '../resource.js';

const baseDomain = process.env.VUE_APP_ENDPOINT;
const baseUrl = `${baseDomain}/api`;
const resource = 'kyc';

export default {
    documents() {
        return resources.get(`${resource}/documents`);
    },
    show(id){
        return resources.get(`application/${id}/${resource}`)
    },
    sendKYC(application) {
        return `${baseUrl}/application/${application}/${resource}`;
    },
    downloadKYC(application) {
        return `${baseUrl}/application/${application}/${resource}/download`;
    },
}
